export default "__VITE_ASSET__CZEPqxEy__"